import React, { useEffect, useMemo, useState } from "react";
import Banner from "../../../components/molecules/v2/Banner";

import Spacer from "../../../components/atoms/Spacer";
import InfoCarousel from "../../../components/molecules/v2/InfoCarousel";
import { Container } from "./Home.styled";
import { func } from "../../../utils";
import Section from "../../../components/atoms/Section";
import JourneyCarousel from "../../../components/molecules/v2/JourneyCarousel";
import {
  usePageContextFunction,
  usePageContextState,
} from "../../../context/PageContext";
import { NewFooter } from "../../../components";
import useWindowSize from "../../../hooks/useWindowSize";
import TimelineSection from "../../../components/molecules/v2/TimelineSection";
import Announce from "../../../components/atoms/Announce";
import Layout from "../../../components/atoms/Layout";
import { FloatingIconWrapper } from "../HomeDetails/HomeDetails.styled";
import * as animationData from "../../../assets/animation/floatingIcon.json";
import Lottie from "react-lottie";
import {
  useFetchEventDetail,
  useFetchGalleryArticle,
  useFetchSection,
  useFetchSocAttribute,
} from "../../../networks";
import Sponsor from "../../../components/atoms/Sponsor";
import GallerySection from "../../../components/molecules/v2/GallerySection";
import BannerSoc from "../../../components/molecules/v2/BannerSoc";
import GuestStars from "../GuestStars/GuestStars";
import TrainingCampSoc from "../../../components/molecules/v2/TrainingCampSoc";
import GallerySoc from "../../../components/molecules/v2/GallerySoc";
import { useParams } from "react-router-dom";
import TimelineSoc from "../../../components/molecules/v2/TimelineSoc";
import HallOfFameCard from "../HomeDetails/HallOfFameCard";
import ChampionsSliderSoc from "../../../components/molecules/v2/ChampionsSliderSoc/ChampionsSliderSoc";
import Show from "../FormRegistration/components/Show";
import moment from "moment";
import TopStats from "../KlasemenPertandinganSoc/components/TopStats";
import Broadcaster from "../../../components/atoms/Broadcaster";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const HomeSoc = ({ slug }) => {
  const { size } = useWindowSize();
  const slugCity = "soc";
  const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

  const isMobileView = (size?.width || 0) <= 768;
  const isSmallScreen = (size?.height || 0) <= 667;
  const [isShowFloating, setIsShowFloating] = useState(true);
  const [navbarShow, setNavbarShow] = useState(false);

  const {
    setPageMode,
    setIdInView,
    setCity,
    setIsLive,
    setVideoUrl,
    setOpenPopUp: toglePopUp,
  } = usePageContextFunction();

  const { idInView } = usePageContextState();
  const { data: dataSectionRaw } = useFetchSection();

  const { data: dataAttributeSoc } = useFetchSocAttribute();

  const dataSection = dataSectionRaw?.data?.data?.sections ?? [];

  const { data: dataGalleryArticle } = useFetchGalleryArticle("soc");
  const dataGalleryRaw = dataGalleryArticle?.data?.data ?? [];

  const trainingCampKV =
    imgPath + dataAttributeSoc?.data?.data?.soc[0]?.background_shadow_kv;
  const trainingCampKVMobile =
    imgPath + dataAttributeSoc?.data?.data?.soc[0]?.background_shadow_kv_mobile;

  const guestStarKV =
    imgPath + dataAttributeSoc?.data?.data?.soc[0]?.key_visual_guest;
  const guestStarKVMobile =
    imgPath + dataAttributeSoc?.data?.data?.soc[0]?.key_visual_guest_mobile;
  const wordingGuest = dataAttributeSoc?.data?.data?.soc[0]?.guest_wording;

  useEffect(() => {
    const element = document.getElementById("announce");
    element.scrollIntoView(false);
    setIdInView("banner");
    setPageMode("slick-scroll");
    setCity("soc");
  }, []);
  /* Listen to navbar clicked */
  useEffect(() => {
    window.addEventListener("click", handleClickNavbar);

    return () => {
      window.removeEventListener("click", handleClickNavbar);
    };
  }, []);
  const isShowFloat = useMemo(() => {
    return (
      isShowFloating && !idInView?.includes("footer-landing") && !navbarShow
    );
  }, [navbarShow, isShowFloating, idInView]);
  const handleHideFloatingIcon = () => {
    setIsShowFloating(false);
  };
  const handleClickNavbar = (e) => {
    const className = String(e.target.className);

    if (className?.includes("navbar")) {
      setNavbarShow(className?.includes("onOpen"));
      handleHideFloatingIcon();
    }
  };

  const { data: dataEventDetail, refetch: refetchEventDetail } =
    useFetchEventDetail(slugCity);
  const dataEvent = dataEventDetail?.data?.data?.eventDetail ?? {};
  const { event_start_date, event_end_date, video_url, registration_url } =
    dataEvent;
  const startDate = moment(event_start_date);
  const endDate = moment(event_end_date);
  const liveStreaming = React.useMemo(() => {
    const currentDate = moment();
    if (
      !!video_url &&
      currentDate.isSameOrAfter(startDate, "day") &&
      currentDate.isSameOrBefore(endDate, "day")
    ) {
      setIsLive(true);
      setVideoUrl(video_url);
      return {
        isLive: true,
      };
    }

    setIsLive(false);
    setVideoUrl("");
    return { isLive: false };
  }, [video_url]);
  // useEffect(() => {
  //   toglePopUp({
  //     state: true,
  //     classNamePopupParent: "!top-0 top-[16px] !bottom-0 inline",
  //     classNamePopupContent: `md:bg-[#151E29] bg-[#1F2D3D] static max-h-none h-screen rounded-none md:rounded-3xl ${
  //       isMobileView ? "mt-0" : "mt-[72px]"
  //     }`,
  //     classNamePopupContainer:
  //       "md:bg-[#151E29] bg-[#1F2D3D] shadow-none w-[100vw] p-0 rounded-none",
  //     closePosition: !isMobileView ? "outside" : "inside",
  //     iconCloseClassname: "md:top-0 top-[16px] right-[16px] absolute !h-[24px]",
  //     typePopUp: "custom-children",
  //     invertCloseColor: true,
  //     children: <TopStats />,
  //   });
  // }, [isMobileView]);
  return (
    <>
      <Layout
        className="box-wrapper"
        scrollSnapType={
          (idInView === "footer-landing" || idInView === "timeline-soc") &&
          isMobileView
            ? "none"
            : "y mandatory"
        }
        overflowY={
          idInView === "footer-landing" || idInView === "timeline-soc"
            ? "unset"
            : "auto"
        }
      >
        <Section id="banner" height={"100vh"} backgroundColor={"#1F2D3D"}>
          <Announce bgColor="#00BCF1" highlightColor="#1F2D3D" />
          <BannerSoc
            data={dataEvent}
            slug={slugCity}
            isLive={liveStreaming?.isLive}
          />
        </Section>

        <Container backgroundColor="#1F2D3D">
          <Section
            id="guest-star"
            alignItems={"center"}
            height={"100vh"}
            backgroundColor={"#1F2D3D"}
          >
            <GuestStars
              guestWording={wordingGuest}
              KV={guestStarKV}
              mobileKV={guestStarKVMobile}
              videoUrl={video_url}
            />
          </Section>
        </Container>

        {/* // Temporary */}
        <Container backgroundColor="#1F2D3D">
          <Section
            id="champion-slider"
            alignItems={"center"}
            height={"100vh"}
            backgroundColor={"#1F2D3D"}
          >
            <ChampionsSliderSoc />
          </Section>
        </Container>

        <Container backgroundColor="#1F2D3D">
          <Section
            id="training-camp"
            alignItems={"center"}
            height={"100vh"}
            backgroundColor={"#1F2D3D"}
          >
            <TrainingCampSoc
              KV={trainingCampKV}
              mobileKV={trainingCampKVMobile}
            />
          </Section>
        </Container>

        <Container backgroundColor="#1F2D3D" paddingTop={"0px"}>
          <Section
            scrollSnap={"start"}
            id="timeline-soc"
            alignItems={"center"}
            height={isMobileView ? "auto" : "100vh"}
            backgroundColor={"#1F2D3D"}
          >
            <TimelineSoc />
          </Section>
        </Container>

        <Container id="hall-of-fame" backgroundColor="#1F2D3D" paddingTop="0">
          <Section id="hall-of-fame" height={"100vh"}>
            <HallOfFameCard
              slug={"soc"}
              soc={true}
              paddingContainerClassname={"md:py-[10vh] py-[3svh]"}
            />
          </Section>
        </Container>

        {dataGalleryRaw?.length !== 0 && (
          <Container backgroundColor="#2e4261">
            <Section
              id="gallery-soc"
              alignItems={"center"}
              height={"100vh"}
              backgroundColor={"#2e4261"}
            >
              <GallerySoc dataGallery={dataGalleryRaw} />
            </Section>
          </Container>
        )}

        <Container
          // backgroundImage={func.getStaticImg("/illustration/swoosh-white.svg")}
          style={{ marginTop: isMobileView ? "-20vh" : "0" }}
          id="jadwal-event"
          backgroundColor={"#1F2D3D"}
          paddingTop="0"
        >
          {/* <Section
            id={"event"}
            alignItems={"center"}
            height={isMobileView ? "100vh" : "94vh"}
          >
            <Fade bottom>
              <Spacer marginLeft={24} marginRight={24} marginTop={16}>
                {Object.keys(eventNearest)?.length > 0 && (
                  <EventNearest title={"Event Terdekat"} data={eventNearest} />
                )}

                {upcomingEvents?.length > 0 && (
                  <EventUpcoming
                    title={"Event Mendatang"}
                    data={upcomingEvents}
                  />
                )}
              </Spacer>
            </Fade>
          </Section> */}
          {/* <Section id="event" display={isMobileView ? "inherit" : "flex"}>
            <JourneyCarousel />
          </Section> */}

          {/* <Container id="info" backgroundColor="#0C1219">
            <Section alignItems={"center"} id="info">
              <InfoCarousel />
            </Section>
          </Container> */}

          {dataSection?.length !== 0 && (
            <>
              {dataSection
                ?.filter((val) => val?.id === 1)
                .map((value, idx) => {
                  if (!value?.section_contents?.length) return null;
                  return (
                    <Section
                      id="footer-landing"
                      padding={"16px 0px 0px 0px"}
                      className={"!relative"}
                      //backgroundColor={isMobileView ? "#F0F2F9" : "white"}
                      height={isMobileView ? "auto" : "50vh"}
                      display={isMobileView ? "inherit" : "flex"}
                    >
                      <img
                        src={func.getStaticImg("/illustration/brush-3.png")}
                        alt="brush"
                        className="absolute left-0 z-10 top-0" // Position at the top
                        style={{
                          transform: "translateY(-40%)", // Move up by 85% of image height
                          maxWidth: "50%",
                          pointerEvents: "none",
                        }}
                      />
                      <img
                        src={func.getStaticImg("/illustration/brush-2.png")}
                        alt="brush"
                        className="absolute right-0 z-10 top-0" // Position at the top
                        style={{
                          transform: "translateY(-40%)", // Move up by 75% of image height
                          maxWidth: "50%",
                          pointerEvents: "none",
                        }}
                      />
                      <Sponsor
                        key={idx}
                        title={value?.section_name}
                        contents={value?.section_contents}
                        titleClassName="text-white"
                      ></Sponsor>
                    </Section>
                  );
                })}
            </>
          )}
          {dataSection?.length !== 0 && (
            <>
              {dataSection
                ?.filter((val) => val?.id === 3)
                ?.map((value, idx) => {
                  if (!value?.section_contents?.length) return null;
                  return (
                    <Section
                      key={idx}
                      id="footer-landing"
                      padding={
                        isMobileView ? "10vh 0px 0px 0px" : "0px 0px 0px 0px"
                      }
                      //backgroundColor={isMobileView ? "#F0F2F9" : "white"}
                      height={isMobileView ? "auto" : "50vh"}
                      display={isMobileView ? "inherit" : "flex"}
                      className={!isMobileView ? "w-1/2" : ""} // Make each section take half the width
                    >
                      {value?.id === 3 && (
                        <Broadcaster
                          key={idx}
                          title={value?.section_name}
                          contents={value?.section_contents}
                          titleClassName="text-white"
                          isInline={!isMobileView} // Pass prop to indicate inline display
                        ></Broadcaster>
                      )}
                      {/* {value?.id === 2 ? (
                        <MediaPartner
                          key={idx}
                          title={value?.section_name}
                          contents={value?.section_contents}
                          titleClassName="text-white"
                          isInline={!isMobileView} // Pass prop to indicate inline display
                        ></MediaPartner>
                      ) : (
                        <Broadcaster
                          key={idx}
                          title={value?.section_name}
                          contents={value?.section_contents}
                          titleClassName="text-white"
                          isInline={!isMobileView} // Pass prop to indicate inline display
                        ></Broadcaster>
                      )} */}
                    </Section>
                  );
                })}
            </>
          )}
          {/* <Section
            id={"footer-landing"}
            height={isMobileView ? "auto" : "750px"}
            scrollSnap={"start"}
          > */}
          <Section id={"footer-landing"} height={"750px"} scrollSnap={"end"}>
            <NewFooter />
          </Section>
          {/* <Section
            id={"footer-landing"}
            height={isSmallScreen ? "115vh" : "100vh"}
            position={"relative"}
            scrollSnap={"start end"}
            alignItems={isSmallScreen ? "start" : "end"}
            display={isSmallScreen ? "inherit" : "flex"}
            padding={isSmallScreen ? "0" : "0 0 8vh 0"}
            // background={`url(http://localhost:3000/static/media/VectorSmall.b65f535e255055fe7b13.svg), #00bcf1`}
          >
            <NewFooter />
          </Section> */}
        </Container>
        {isShowFloat && (
          <FloatingIconWrapper
            key={isShowFloat}
            style={isShowFloat ? styles.onShow : styles.onHide}
            onClick={() => {
              func.scrollTo("footer-landing");
            }}
          >
            <Lottie
              style={{ width: 120, height: 120 }}
              options={{
                animationData: animationData,
              }}
            />
          </FloatingIconWrapper>
        )}
      </Layout>
    </>
  );
};

const styles = {
  onHide: {
    opacity: 0,
  },
  onShow: {
    opacity: 1,
    transition: "opacity 0.2s linear",
  },
};

export default HomeSoc;
